import { graphql } from 'gatsby';

export const CookieConsentFragment = graphql`
    fragment PrismicCookieConsentFragment on PRISMIC_Cookie_consent {
        ...MetaFragment
        cookie_consent_description
        cookie_consent_agree_text
    }
`;
